import { ScrollView, View } from 'react-native';
import { FullHeightWrapper } from '~/layout/components/full-height-wrapper/FullHeightWrapper';
import { MealsHeader } from '~/meal/components/meals-header/MealsHeader';
import { MealHistorySection } from '~/meal/components/meal-history-section/MealHistorySection';
import { MealStatsSection } from '~/meal/components/meal-stats-section/MealStatsSection';
import { CustomMealsSection } from '~/meal/components/custom-meals-section/CustomMealsSection';
import { FavoriteMealsSection } from '~/meal/components/favorite-meals-section/FavoriteMealsSection';

export interface MealsScreenProps {}

export const MealsScreen = ({}: MealsScreenProps) => {
  return (
    <FullHeightWrapper>
      <MealsHeader />
      <ScrollView className="flex-1" showsVerticalScrollIndicator={false}>
        <View className="p-8 gap-6">
          <MealsHeader.Body className="md:hidden" />
          <View className="flex flex-col gap-6 md:flex-row">
            <View className="flex flex-col gap-6 md:flex-1">
              <MealHistorySection />
              <CustomMealsSection />
            </View>
            <View className="flex flex-col gap-6 md:flex-1">
              <MealStatsSection />
              <FavoriteMealsSection />
            </View>
          </View>
        </View>
      </ScrollView>
    </FullHeightWrapper>
  );
};
